// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.system-role-list[data-v-29936004]{\n  margin: 48px;\n  background-color: #fff;\n}\n.filter-container[data-v-29936004]{\n  padding: 24px;\n  text-align: right;\n}\n.search-frame[data-v-29936004] {\n  width: 160px;\n  margin-left: 5px;\n}\n.search-btn[data-v-29936004] {\n  margin-left: 10px;\n}\n.add-btn[data-v-29936004]{\n  color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
